import request from 'superagent';

class Request {
  static getAppBaseUri() {
    return '/sapiturProtocolo/';
  }

  static getApiUri() {
    return `${Request.getAppBaseUri()}api/`;
  }

  static getUrlBrasao() {
    return `${Request.getAppBaseUri()}assets/brasao`;
  }

  static errorCallback(error, callback) {
    if (callback) {
      callback(error.response.body);
    } else {
      alert(error.response.body.message);
    }
  }

  /**
   * Envia uma requisição GET para o caminho especificado
   * @param {String} path
   * @param {function(params)} callback
   * @param {function(params)} errorCallback
   */
  static get(path, callback, errorCallback) {
    request.get(Request.getApiUri() + path)
      .accept('application/json')
      .then((response) => {
        callback(response.body.data);
      }, (error) => {
        Request.errorCallback(error, errorCallback);
      });
  }

  /**
   * Envia uma requisição POST para o caminho especificado
   * @param {String} path
   * @param {JSON} data
   * @param {function(params)} callback
   * @param {function(params)} errorCallback
   */
  static post(path, data, callback, errorCallback) {
    request.post(Request.getApiUri() + path)
      .send(data)
      .type('application/json')
      .accept('application/json')
      .then((response) => {
        callback(response.body.data);
      }, (error) => {
        Request.errorCallback(error, errorCallback);
      });
  }

  /**
   * Envia uma requisição PUT para o caminho especificado
   * @param {String} path
   * @param {JSON} data
   * @param {function(params)} callback
   * @param {function(params)} errorCallback
   */
  static put(path, data, callback, errorCallback) {
    request.put(Request.getApiUri() + path)
      .send(data)
      .type('application/json')
      .accept('application/json')
      .then((response) => {
        callback(response.body.data);
      }, (error) => {
        Request.errorCallback(error, errorCallback);
      });
  }

  /**
   * Envia uma requisição DELETE para o caminho especificado
   * @param {String} path
   * @param {JSON} data
   * @param {function(params)} callback
   * @param {function(params)} errorCallback
   */
  static delete(path, data, callback, errorCallback) {
    request.del(Request.getApiUri() + path)
      .send(data)
      .type('application/json')
      .accept('application/json')
      .then((response) => {
        callback(response.body.data);
      }, (error) => {
        Request.errorCallback(error, errorCallback);
      });
  }

  // Consulta a versao atual do sistema
  static getVersaoSistema(callback) {
    Request.get('parametro/versaosistema', callback);
  }

  // Busca e retorna um unico parametro
  static getParametro(parametro, callback) {
    Request.get('parametro/' + parametro, callback);
  }

  // Busca e retorna um array com um ou mais parametros
  static getParametros(parametros, callback) {
    Request.post('parametro/', parametros, callback);
  }

  static getUnidadeGestoraPadrao(callback) {
    Request.get('unidadegestora/padrao', callback);
  }

  static baixarManual(path, errorCallback) {
    request.get(path)
      .responseType('blob')
      .end((err, response) => {
        if (!err && response) {
          let nomeArquivo = 'manual.pdf';
          if (typeof response.headers['content-disposition'] !== 'undefined') {
            nomeArquivo = response.headers['content-disposition'].match(/filename="(.+)"/)[1];
          }
          Request.fileDownload(response.body, response.body.type, nomeArquivo);
        } else {
          Request.errorCallback(err, errorCallback);
        }
      }, (error) => {
        Request.errorCallback(error, errorCallback);
      });
  }

  static imrpimeRelatorio(nomeRelatorio, data, errorCallback) {
    let uri = Request.getApiUri() + 'relatorio/imprimir/' + nomeRelatorio;
    request.post(uri)
      .send(data)
      .type('application/json')
      .responseType('blob')
      .end((err, response) => {
        if (!err && response) {
          let nomeArquivo = 'relatorio.pdf';
          if (typeof response.headers['content-disposition'] !== 'undefined') {
            nomeArquivo = response.headers['content-disposition'].match(/filename="(.+)"/)[1];
          }
          Request.fileDownload(response.body, response.body.type, nomeArquivo);
        } else {
          Request.errorCallback(err, errorCallback);
        }
      }, (error) => {
        Request.errorCallback(error, errorCallback);
      });
  }

  static fileDownload(data, mimeType, filename) {
    var blob = new Blob([data], { type: mimeType });
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      // IE workaround for HTML7007
      window.navigator.msSaveBlob(blob, filename);
    } else {
      var fileURL = window.URL.createObjectURL(blob);
      var tempLink = document.createElement('a');
      tempLink.href = fileURL;
      tempLink.setAttribute('download', filename);
      tempLink.setAttribute('target', '_blank');
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
    }
  }
}

export default Request;


// WEBPACK FOOTER //
// ./src/modulos/Request.js